import { render, staticRenderFns } from "./ChipTemplate.vue?vue&type=template&id=0dd23207&"
import script from "./ChipTemplate.vue?vue&type=script&lang=js&"
export * from "./ChipTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports